<div class="modal-container">
  <div mat-dialog-title>
    <div class="modal__header">
      <div class="modal__title">
        <h1>Another Change Request has been merged into this Scope</h1>
      </div>

      <button
        class="close-button"
        mat-dialog-close>
        <mat-icon class="material-symbols-rounded">close</mat-icon>
      </button>
    </div>
  </div>

  <mat-dialog-content>
    <div class="modal__body pb-7">
      <div>
        Your scenario configuration of this change request must be updated to the latest version before you can
        continue.
      </div>
      <div class="mt-2">
        Click <strong>Rebase</strong> to start the update process. We will merge the latest scenario configuration
        answers into your changes and regenerate everything based on it.
      </div>
      <div class="mt-4"><strong>Please note:</strong></div>
      <ul class="mt-2">
        <li>Any manual changes will be lost during the rebase process.</li>
        <li>If needed, close this dialog and note your manual changes before continuing.</li>
        <li>
          You will not be able to make further changes to this Change Request until the rebase process is complete.
        </li>
      </ul>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions class="flex gap-2 d-justify-flex-end">
    <button
      mat-button
      class="scope-ui-modal-button"
      (click)="cancel()">
      Cancel
    </button>
    <button
      mat-button
      class="confirm scope-ui-modal-button"
      (click)="confirm()">
      Rebase
    </button>
  </mat-dialog-actions>
</div>
